import React, { useEffect, useState } from 'react'
import { FaArrowLeft, FaTimes } from 'react-icons/fa';
import { apiPut } from '../../API/Api_Url';
import { toast } from 'react-toastify';

function UpdateFreelancerJobPostModel({ SelectedRequirement, isOpen, onClose, GetUserAllPendingFreelancerJobPost }) {

    const [IsLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [Title, setTitle] = useState("");
    const [Description, setDescription] = useState("");
    const [Skillsrequire, setSkillsrequire] = useState([]);
    const [Address, setAddress] = useState("");
    const [City, setCity] = useState("");
    const [State, setState] = useState("");
    const [Budget, setBudget] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [skillInput, setSkillInput] = useState("");

    useEffect(() => {
        setTitle(SelectedRequirement?.Title)
        setDescription(SelectedRequirement?.Description)
        setSkillsrequire(SelectedRequirement?.Skillsrequire || []);
        setAddress(SelectedRequirement?.location?.Address)
        setCity(SelectedRequirement?.location?.City)
        setState(SelectedRequirement?.location?.State)
        setBudget(SelectedRequirement?.Budget)
        setStartDate(
            SelectedRequirement?.timeline?.startDate
                ? new Date(SelectedRequirement.timeline.startDate)
                    .toISOString()
                    .split("T")[0]
                : ""
        );
        setEndDate(
            SelectedRequirement?.timeline?.endDate
                ? new Date(SelectedRequirement.timeline.endDate)
                    .toISOString()
                    .split("T")[0]
                : ""
        );
    }, [SelectedRequirement]);

    const handleAddSkill = () => {
        if (skillInput.trim() && !Skillsrequire.includes(skillInput.trim())) {
            setSkillsrequire([...Skillsrequire, skillInput.trim()]);
        }
        setSkillInput("");
    };

    const handleRemoveSkill = (skill) => {
        setSkillsrequire(Skillsrequire.filter((s) => s !== skill));
    };


    const handleUpdateFreelancerJobPost = async () => {
        let newErrors = {};

        if (!Title.trim()) newErrors.Title = "Title is required";
        if (!Description.trim()) newErrors.Description = "Description is required";
        if (Skillsrequire.length ===0 ) newErrors.Skillsrequire = "Skills are required";
        if (!Address.trim()) newErrors.Address = "Address is required";
        if (!City.trim()) newErrors.City = "City is required";
        if (!State.trim()) newErrors.State = "State is required";
        if (!Budget) newErrors.Budget = "Budget is required";
        if (!startDate.trim()) newErrors.startDate = "Start date is required";
        if (!endDate.trim()) newErrors.endDate = "End date is required";

        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;

        const payload = {
            Title,
            Description,
            Skillsrequire: Skillsrequire,
            location: {
                Address,
                City,
                State,
            },
            Budget,
            timeline: {
                startDate,
                endDate,
            },
        };

        try {
            setIsLoading(true);
            const response = await apiPut(
                `/api/user/UserupdateFreelancerJobPost/${SelectedRequirement?._id}`,
                payload
            );
            if (response?.data) {
                toast.success(
                    response?.data?.message ||
                    response?.message ||
                    "Job post Updated successfully!"
                );
                setTitle("");
                setDescription("");
                setSkillsrequire("");
                setAddress("");
                setCity("");
                setState("");
                setBudget("");
                setStartDate("");
                setEndDate("");
                onClose()
                GetUserAllPendingFreelancerJobPost()
            } else {
                toast.error(response?.message || "Failed to create job post");
            }
        } catch (error) {
            console.error("Error uploading requirement:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    }

    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-lg p-8 max-w-4xl w-full overflow-y-auto max-h-[90vh]">
                <div className="flex items-center mb-6">
                    <FaArrowLeft
                        className="mr-3 cursor-pointer text-gray-600 hover:text-gray-800 transition"
                        onClick={onClose}
                    />
                    <h2 className="text-2xl font-semibold text-gray-800">Update Freelancer Job Post</h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 pt-5">
                    <div className="md:col-span-2">
                        <label className="block mb-1 font-medium">
                            Title<span className="text-red-500">*</span>
                        </label>
                        <input
                            className={`form-input w-full ${errors?.Title ? "border-red-500" : ""
                                }`}
                            type="text"
                            placeholder="Enter Title"
                            value={Title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                        {errors?.Title && (
                            <p className="text-red-500 text-sm mt-1">{errors?.Title}</p>
                        )}
                    </div>

                    <div className="md:col-span-2">
                        <label className="block mb-1 font-medium">
                            Description<span className="text-red-500">*</span>
                        </label>
                        <textarea
                            className={`form-input w-full ${errors?.Description ? "border-red-500" : ""
                                }`}
                            placeholder="Enter Description"
                            value={Description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                        {errors?.Description && (
                            <p className="text-red-500 text-sm mt-1">
                                {errors?.Description}
                            </p>
                        )}
                    </div>
                    <div className="md:col-span-2">
                        <label className="block mb-1 font-medium">
                            Skills<span className="text-red-500">*</span>
                        </label>
                        <div className="flex gap-2 mb-2">
                            <input
                                className="form-input flex-1"
                                type="text"
                                placeholder="e.g. Structural Design"
                                value={skillInput}
                                onChange={(e) => setSkillInput(e.target.value)}
                                onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), handleAddSkill())}
                            />
                            <button
                                type="button"
                                onClick={handleAddSkill}
                                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                            >
                                Add
                            </button>
                        </div>

                        <div className="flex flex-wrap gap-2">
                            {Skillsrequire?.map((skill, idx) => (
                                <span
                                    key={idx}
                                    className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full flex items-center gap-2 text-sm"
                                >
                                    {skill}
                                    <FaTimes
                                        className="cursor-pointer hover:text-red-500"
                                        onClick={() => handleRemoveSkill(skill)}
                                    />
                                </span>
                            ))}
                        </div>

                        {errors?.Skillsrequire && (
                            <p className="text-red-500 text-sm mt-1">{errors?.Skillsrequire}</p>
                        )}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">
                            Address<span className="text-red-500">*</span>
                        </label>
                        <input
                            className={`form-input w-full ${errors?.Address ? "border-red-500" : ""
                                }`}
                            type="text"
                            placeholder="Enter Address"
                            value={Address}
                            onChange={(e) => setAddress(e.target.value)}
                        />
                        {errors?.Address && (
                            <p className="text-red-500 text-sm mt-1">
                                {errors?.Address}
                            </p>
                        )}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">
                            City<span className="text-red-500">*</span>
                        </label>
                        <input
                            className={`form-input w-full ${errors?.City ? "border-red-500" : ""
                                }`}
                            type="text"
                            placeholder="Enter City"
                            value={City}
                            onChange={(e) => setCity(e.target.value)}
                        />
                        {errors?.City && (
                            <p className="text-red-500 text-sm mt-1">{errors?.City}</p>
                        )}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">
                            State<span className="text-red-500">*</span>
                        </label>
                        <input
                            className={`form-input w-full ${errors?.State ? "border-red-500" : ""
                                }`}
                            type="text"
                            placeholder="Enter State"
                            value={State}
                            onChange={(e) => setState(e.target.value)}
                        />
                        {errors?.State && (
                            <p className="text-red-500 text-sm mt-1">{errors?.State}</p>
                        )}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">
                            Budget<span className="text-red-500">*</span>
                        </label>
                        <input
                            className={`form-input w-full ${errors?.Budget ? "border-red-500" : ""
                                }`}
                            type="text"
                            placeholder="Enter Budget"
                            value={Budget}
                            onChange={(e) => setBudget(e.target.value)}
                        />
                        {errors?.Budget && (
                            <p className="text-red-500 text-sm mt-1">{errors?.Budget}</p>
                        )}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">
                            Start Date<span className="text-red-500">*</span>
                        </label>
                        <input
                            className={`form-input w-full ${errors?.startDate ? "border-red-500" : ""}`}
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                        />
                        {errors?.startDate && (
                            <p className="text-red-500 text-sm mt-1">{errors?.startDate}</p>
                        )}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">
                            End Date<span className="text-red-500">*</span>
                        </label>
                        <input
                            className={`form-input w-full ${errors?.endDate ? "border-red-500" : ""}`}
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                        {errors?.endDate && (
                            <p className="text-red-500 text-sm mt-1">{errors?.endDate}</p>
                        )}
                    </div>
                </div>

                <button
                    onClick={handleUpdateFreelancerJobPost}
                    disabled={IsLoading}
                    className={`w-full mt-8 text-white py-3 rounded-full font-medium transition 
          ${IsLoading ? "bg-gray-400 cursor-not-allowed" : "bg-gradient-to-r from-blue-500 to-red-500 hover:opacity-90"}`}
                >
                    {IsLoading ? "Updating..." : "Update Requirement"}
                </button>
            </div>
        </div>
    )
}

export default UpdateFreelancerJobPostModel